import { CheckCircle2 } from "lucide-react";
import { Reveal, SectionHeading } from "../components/Reveal";
import { Watermark } from "../components/Gunungan";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1653924333410-0dda83ae490c?auto=format&fit=crop&w=1400&q=80";

export default function TentangPage() {
  return (
    <section className="relative overflow-hidden">
      <Watermark className="pointer-events-none absolute -right-16 top-16 hidden h-[420px] w-auto text-gold opacity-[0.06] lg:block" />
      <div className="wrap relative grid items-center gap-12 py-16 sm:py-24 lg:grid-cols-2 lg:gap-20">
        <div>
          <SectionHeading eyebrow="Tentang Kami" title="Putra Bengawan Logistik" />
          <Reveal delay={0.2}>
            <p className="mt-6 leading-relaxed text-zinc-400">
              Putra Bengawan Logistik adalah perusahaan transportasi dengan fokus layanan logistik
              dan pengiriman barang untuk kebutuhan bisnis. Kami melayani pelanggan yang beragam —
              mulai dari pengusaha, pemilik atau pengelola gudang, hingga perusahaan manufaktur.
            </p>
            <p className="mt-4 leading-relaxed text-zinc-400">
              Armada kami merupakan sarana pendukung kegiatan pengiriman dan operasional logistik
              pelanggan. Setiap unit armada kami diberi nama tokoh wayang Jawa — sebuah penanda
              karakter dan tanggung jawab pada setiap perjalanan. Katalog armada di website ini
              membantu Anda melihat setiap kategori dan unit sebelum menghubungi tim kami.
            </p>
          </Reveal>
          <ul className="mt-8 grid gap-3 sm:grid-cols-2">
            {[
              "Armada sendiri dengan beragam kategori",
              "Dukungan transportasi untuk distribusi barang",
              "Melayani kebutuhan pelanggan bisnis",
              "Komunikasi langsung dengan tim",
            ].map((item) => (
              <li key={item} className="flex items-start gap-2.5 text-sm text-zinc-300">
                <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
                {item}
              </li>
            ))}
          </ul>
        </div>
        <Reveal delay={0.15} className="relative">
          <div className="overflow-hidden rounded-2xl border border-zinc-800">
            <img
              src={ABOUT_IMG}
              alt="Armada Putra Bengawan Logistik"
              loading="lazy"
              className="aspect-[4/3] w-full object-cover"
            />
          </div>
          <div
            className="glass-bar absolute -bottom-6 left-6 rounded-xl px-6 py-4"
            data-testid="tentang-badge-armada"
          >
            <p className="font-display text-3xl font-extrabold text-gold-deep">22 Unit</p>
            <p className="mt-0.5 text-xs text-zinc-400">Armada siap mendukung kebutuhan bisnis</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
